<template>
  <v-form
    ref="driverForm"
    v-model="valid"
  >
    <v-layout wrap class="pl-2">
      <v-flex
        xs6
        md4
        px-2
      >
        <label class="cmr-label-text">Address Line 1</label>
        <v-text-field
          v-model="driverDetails.address_line_1"
          dense
          outlined
          :error-messages="errorForField('address_line_1')"
          maxlength="100"
          :rules="driverDetailsRules.address_line_1"
          @input="resetError('address_line_1')"
        />
      </v-flex>
      <v-flex
        xs6
        md4
        px-2
      >
        <label class="cmr-label-text">Address Line 2</label>
        <v-text-field
          v-model="driverDetails.address_line_2"
          :error-messages="errorForField('address_line_2')"
          maxlength="100"
          :rules="driverDetailsRules.address_line_2"
          dense
          outlined
          @input="resetError('address_line_2')"
        />
      </v-flex>
      <v-flex
        xs6
        md4
        px-2
      >
        <label class="cmr-label-text">Town</label>
        <v-text-field
          v-model="driverDetails.town"
          :error-messages="errorForField('town')"
          maxlength="50"
          :rules="driverDetailsRules.town"
          dense
          outlined
          @input="resetError('town')"
        />
      </v-flex>
      <v-flex
        xs6
        md4
        px-2
      >
        <label class="cmr-label-text">Country</label>
        <v-text-field
          v-model="driverDetails.county"
          :error-messages="errorForField('county')"
          maxlength="50"
          :rules="driverDetailsRules.county"
          dense
          outlined
          @input="resetError('county')"
        />
      </v-flex>
      <v-flex
        xs6
        md4
        px-2
      >
        <label class="cmr-label-text">Post Code</label>
        <v-text-field
          v-model="driverDetails.postcode"
          :error-messages="errorForField('postcode')"
          maxlength="8"
          :rules="driverDetailsRules.postcode"
          outlined
          dense
          @input="resetError('postcode')"
        />
      </v-flex>
      <v-flex
        xs6
        md4
        px-2
      >
        <label class="cmr-label-text">Home Phone Number</label>
        <v-text-field
          v-model="driverDetails.home_phone"
          :error-messages="errorForField('home_phone')"
          maxlength="12"
          type="number"
          class="noStepNumber"
          :rules="driverDetailsRules.home_phone"
          dense
          outlined
          @input="resetError('home_phone')"
        />
      </v-flex>
    </v-layout>
  
    <v-layout
      style="width: 100%"
      wrap
    >
      <v-flex
        xs12
        pl-2
      >
        <v-layout
          pt-2
          class="field-padding"
          wrap
        >
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Call sign</label>
            <v-text-field
              v-model="driver.callsign"
              :error-messages="errorForField('callsign')"
              :rules="driverRules.callsign"
              dense
              outlined
              @input="resetError('callsign')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Commission Percentage p1</label>
            <v-text-field
              v-model="driver.fee_percentage"
              :error-messages="errorForField('fee_percentage')"
              :rules="driverRules.fee_percentage"
              type="number"
              step="1"
              suffix="%"
              dense
              outlined
              @input="resetError('fee_percentage')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Weekly Charge Amount</label>
            <v-text-field
              v-model="driver.weekly_charge_amount"
              :error-messages="errorForField('weekly_charge_amount')"
              :rules="driverRules.weekly_charge_amount"
              type="number"
              step="1"
              suffix=""
              dense
              outlined
              @input="resetError('weekly_charge_amount')"
            />
          </v-flex>
          
          <v-flex md12 >
            <v-divider></v-divider>
          </v-flex>
          <v-flex md12 class="mt-2">
            <h3>License</h3>
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Driver License Number</label>
            <v-text-field
              v-model="driver.driving_license_number"
              :error-messages="errorForField('driving_license_number')"
              :rules="driverRules.driving_license_number"
              dense
              outlined
              @input="resetError('driving_license_number')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Hackney Carriage Number</label>
            <v-text-field
              v-model="driver.hackney_number"
              :error-messages="errorForField('hackney_number')"
              maxlength="5"
              type="number"
              dense
              outlined
              class="noStepNumber"
              :rules="driverRules.hackney_number"
              @input="resetError('hackney_number')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Private Hire Number</label>
            <v-text-field
              v-model="driver.private_hire_number"
              :error-messages="errorForField('private_hire_number')"
              maxlength="5"
              type="number"
              class="noStepNumber"
              dense
              outlined
              :rules="driverRules.private_hire_number"
              @input="resetError('private_hire_number')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Driving License Expiry</label>
            <DateInputIcon
              v-model="driver.driving_license_expiry"
              :error-messages="errorForField('driving_license_expiry')"
              :rules="driverRules.driving_license_expiry"
              :clearable="true"
              @input="resetError('driving_license_expiry')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Hackney Carriage Expiry</label>
            <DateInputIcon
              v-model="driver.hackney_expiry"
              :error-messages="errorForField('hackney_expiry')"
              :rules="driverRules.hackney_expiry"
              :clearable="true"
              @input="resetError('hackney_expiry')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Private Hire Expiry</label>
            <DateInputIcon
              v-model="driver.private_hire_expiry"
              :error-messages="errorForField('private_hire_expiry')"
              :rules="driverRules.private_hire_expiry"
              :clearable="true"
              @input="resetError('private_hire_expiry')"
            />
          </v-flex>
          <v-flex
            class="field-padding mb-2 ml-1"
            row
            wrap
          >
            <v-layout row>
              <v-flex
              >
                <v-btn-toggle
                  class="px-1"
                  v-model="driverDetails.adt"
                  color="primary"
                  dense
                >
                  <v-btn
                    :value="true"
                    text
                    small
                    class="cmr-label-text"
                  >
                    Advanced Driver Training
                  </v-btn>
                </v-btn-toggle>
                <v-btn-toggle
                  class="px-1"
                  v-model="driverDetails.b_tech"
                  color="primary"
                  dense
                >
                  <v-btn
                    small
                    :value="true"
                    text
                  >
                    B-Tech
                  </v-btn>
                </v-btn-toggle>
                <v-btn-toggle
                  class="px-1"
                  v-model="driverDetails.nvq"
                  color="primary"
                  :disabled="disabled"
                  dense
                >
                  <v-btn
                    small
                    :value="true"
                    text
                  >
                    NVQ
                  </v-btn>
                </v-btn-toggle>
                <v-btn-toggle
                  class="px-1"
                  v-model="driverDetails.wheelchair_cert"
                  color="primary"
                  :disabled="disabled"
                  dense
                >
                  <v-btn
                    small
                    :value="true"
                    text
                  >
                    Wheelchair
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-layout>
        <v-flex
          pt-2
          class="field-padding"
          row
          wrap
        >
          <v-divider class="my-3"></v-divider>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import DateInputIcon from "@/components/widget/input/DateInputIconV2.vue";
import FileInput from "@/components/widget/input/FileInput.vue";
import CurrentFiles from "@/components/driver/CurrentFilesV2.vue";

export default {
  name: "DriverFormV2",
  components: {
    DateInputIcon,
    FileInput,
    CurrentFiles,
  },
  props: {
    driver: Object,
    driverDetails: Object,
    errors: { type: Object, default: () => {} },
    currentDocuments: { type: Array, default: () => [] },
    pictureUrl: { type: String, default: "" },
  },
  data: function () {
    return {
      valid: false,
      disabled: false,
      driverRules: {
        driving_license_number: [],
        callsign: [
          (v) =>
            !v ||
            (v.length > 0 && v.length < 6) ||
            "Callsign must not exceed 6 digits",
        ],
        hackney_number: [
          (v) =>
            !v ||
            (v.length >= 1 && v.length <= 6) ||
            "Hackney carriage number must be from 3 to 6 digits",
        ],
        private_hire_number: [
          (v) =>
            !v ||
            (v.length >= 1 && v.length <= 6) ||
            "Private hire number must be from 3 to 6 digits",
        ],
        driving_license_expiry: [
          (v) =>
            !v ||
            /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(v) ||
            "Driving license expiry is in an invalid format",
        ],
        hackney_expiry: [],
        private_hire_expiry: [],
        fee_percentage: [
          (v) =>
            !v ||
            (v && parseInt(v) >= 10 && parseInt(v) <= 100) ||
            "Commission Percentage must be between 10 and 100",
        ],
        picture: [],
        documentDescription: [(v) => !!v || "Document description is required"],
      },
      driverDetailsRules: {
        address_line_1: [
          (v) =>
            (v || "").length <= 100 ||
            "First address line cannot exceed 100 characters",
        ],
        address_line_2: [
          (v) =>
            (v || "").length <= 100 ||
            "Second address line cannot exceed 100 characters",
        ],
        town: [
          (v) => (v || "").length <= 50 || "Town cannot exceed 50 characters",
        ],
        county: [
          (v) => (v || "").length <= 50 || "County cannot exceed 50 characters",
        ],
        postcode: [
          (v) => (v || "").length <= 8 || "Town cannot exceed 8 characters",
        ],
        home_phone: [
          (v) =>
            (v || "").length <= 12 ||
            "Home phone number cannot exceed 12 digits",
        ],
      },
      documentFiles: [],
    };
  },
  watch: {
    documentFiles: {
      handler: function () {
        this.$emit("documentInput", this.documentFiles);
      },
      deep: true,
    },
    valid: function () {
      this.$emit("validityChange", this.valid);
    },
    pictureUrl: function () {
      console.log("Picture URL");

      this.driverRules.picture = [];
      this.errors["picture"] = "";
      let rule;
      if (this.pictureUrl == null || this.pictureUrl == "") {
        rule = (v) => !!v || "Photo is required";
      } else {
        rule = (v) =>
          v == null ||
          v == "" ||
          "Please delete current driver image to use a new one";
      }
      this.driverRules.picture.push(rule);
      this.$refs.driverForm.resetValidation();
    },
  },
  methods: {
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function (field) {
      try {
        if (field == "hackney_number") {
          this.errors["hackney_number"] = "";
          this.errors["hackney_expiry"] = "";
          this.errors["private_hire_number"] = "";
        }
        if (field == "private_hire_number") {
          this.errors["private_hire_number"] = "";
          this.errors["private_hire_expiry"] = "";
          this.errors["hackney_number"] = "";
        }
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    handleImageInput: function (file) {
      this.$emit("imageInput", file);

      this.driverRules.picture = [];
      this.errors.picture = "";
      this.$refs.driverForm.resetValidation();

      console.log("Image input");
      console.log(this.errors);
    },
    handleDocumentInput: function (files) {
      let newDocumentFiles = [];
      files.forEach(function (file) {
        let newFile = {
          ...file,
          description: "",
        };
        newDocumentFiles.push(newFile);
      });
      this.documentFiles = newDocumentFiles;
    },
    validateForm: function () {
      this.$refs.driverForm.validate();
    },
    deletePicture: function () {
      this.$emit("deletePicture");
    },
    deleteDocument: function (fileID) {
      this.$emit("deleteDocument", fileID);
    },
    viewDocument: function (fileID) {
      this.$emit("viewDocument", fileID);
    },
  },
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>